import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { X, Download, QrCode, RefreshCw } from 'lucide-react';

export default function QRModal({ doctor, onClose, onUpdate }) {
  const [loading, setLoading] = useState(false);
  const [qrCode, setQrCode] = useState(doctor.qrCode || '');

  const generateQR = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/doctors/${doctor._id}/generate-qr`);
      setQrCode(res.data.qrCode);
      onUpdate({ ...doctor, qrCode: res.data.qrCode });
      toast.success('QR Code generated!');
    } catch (err) {
      toast.error('Failed to generate QR');
    } finally {
      setLoading(false);
    }
  };

  const downloadQR = (format) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 500;
      canvas.height = 560;
      const ctx = canvas.getContext('2d');

      // White background
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, 500, 560);

      // Purple header
      ctx.fillStyle = '#6B21A8';
      ctx.fillRect(0, 0, 500, 80);
      ctx.fillStyle = 'white';
      ctx.font = 'bold 20px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('Hilton Pharma', 250, 38);
      ctx.font = '13px Arial';
      ctx.fillText('QR Campaign System', 250, 60);

      // QR code
      ctx.drawImage(img, 50, 100, 400, 400);

      // Doctor name below
      ctx.fillStyle = '#1F2937';
      ctx.font = 'bold 18px Arial';
      ctx.fillText(`${doctor.name}`, 250, 530);

      const link = document.createElement('a');
      link.download = `QR_Dr_${doctor.name.replace(/\s+/g, '_')}.${format}`;
      link.href = canvas.toDataURL(format === 'jpg' ? 'image/jpeg' : 'image/png', 0.95);
      link.click();
      toast.success(`Downloaded as ${format.toUpperCase()}`);
    };
    img.src = qrCode;
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 420, textAlign: 'center' }}>
        <div className="modal-header">
          <h2 style={{ fontSize: '1.1rem' }}>QR Code — {doctor.name}</h2>
          <button className="modal-close" onClick={onClose}><X size={20} /></button>
        </div>

        {!qrCode ? (
          <div style={{ padding: '40px 20px' }}>
            <div style={{ width: 80, height: 80, background: 'var(--purple-100)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <QrCode size={36} color="var(--purple-800)" />
            </div>
            <p style={{ color: 'var(--gray-600)', marginBottom: 24, fontSize: '0.9rem' }}>
              No QR code generated yet. Click below to generate one for this doctor's profile.
            </p>
            <button className="btn btn-primary" onClick={generateQR} disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? <><div className="spinner" />&nbsp;Generating...</> : <><QrCode size={16} /> Generate QR Code</>}
            </button>
          </div>
        ) : (
          <>
            <div style={{ background: 'var(--gray-50)', borderRadius: 12, padding: 20, marginBottom: 20, display: 'inline-block' }}>
              <img src={qrCode} alt="QR Code" style={{ width: 220, height: 220, display: 'block' }} />
            </div>

            <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)', marginBottom: 20 }}>
              Scan this QR to visit {doctor.name}'s profile page
            </p>

            <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
              <button className="btn btn-primary" onClick={() => downloadQR('png')} style={{ flex: 1, justifyContent: 'center' }}>
                <Download size={15} /> Download PNG
              </button>
              <button className="btn btn-outline" onClick={() => downloadQR('jpg')} style={{ flex: 1, justifyContent: 'center' }}>
                <Download size={15} /> Download JPG
              </button>
            </div>
            <button className="btn btn-outline btn-sm" onClick={generateQR} disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? <><div className="spinner" style={{ borderTopColor: 'var(--purple-800)' }} />&nbsp;Regenerating...</> : <><RefreshCw size={13} /> Regenerate QR</>}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
